// Employee API Services

import axios from "../../../../axios";
import Cookies from "js-cookie";

export const createEmployee = async (formData) => {
  const token = Cookies.get("employeeToken");

  if (!token) {
    throw new Error("Login token missing.");
  }

  const payload = {
    token,
    ...formData, 
  };

  return axios.post("/api/Admin/Employee/CreateEmployee", payload);
};


export const bulkCreateEmployee = async (file) => {
  const token = Cookies.get("employeeToken");

  if (!token) {
    throw new Error("Login token missing.");
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("token", token);

  return axios.post(
    "/api/Admin/Employee/BulkCreateEmployee",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
